import { useRef, useState, useContext, useEffect } from "react";
import {useNavigate} from 'react-router-dom';
import {SalubrisContext} from './Context';
import Section from "./Section";
import Button from "./Button";

import mixpanel from 'mixpanel-browser';
mixpanel.init('dad63d43256c11b54faf7cf812a51631');

const Home = () =>  {

    let navigate = useNavigate();
    const {actions} = useContext(SalubrisContext);

    const [error, setError] = useState('');
    const [typeAdult, setTypeAdult] = useState(true);
    const [typePediatrics, setTypePediatrics] = useState(true);
    const typeName = useRef();
    const typeLocation = useRef();
    const selectRadius = useRef();

    useEffect(() => {

        mixpanel.identify();
        mixpanel.track_pageview({"page":'Find Doctors'});
        mixpanel.track('Find Doctors Page Visited'); 
    },[]);

    const handleSubmit = (e) => {

        e.preventDefault();
        const name = typeName.current.value;
        const location = typeLocation.current.value;
        const radius = selectRadius.current.value;
        const type = typeAdult && !typePediatrics ? 'adult': (!typeAdult && typePediatrics ? 'pediatrics' : 'both');
        
        const url = name.length ? `centers/${location}/${radius}/${type}/${name}` : (
            type !== 'both' ? `centers/${location}/${radius}/${type}` : `centers/${location}/${radius}`
        )
        if(location.length) {

            actions.setCenters([]);
            mixpanel.track('Find Doctors Search Triggered');
            navigate(url);
        }
        else setError('Location is required');
    }

    // const typeClickHandle = (e) => {

    //     setType(e.target.value);
    // }

    const locationChangeHandle = (e) => {

        setError(e.target.value.length ? '' : 'Location is required');
    }

    return (
        [<div className="full-width banner" key={1}>
            <Section key="section-1">
                <div className="sub-section">
                    <span className="margin-bottom">Find the Care<br className="dt"></br> You Need</span>
                    <p>Search below by name or<br className="dt"></br> your location.</p>
                </div>
            </Section>
            <img src="/find-doctors/images/home_intro_bg_1.jpg" alt="Home Page Banner" />
        </div>,
        <div className="search-container margin-top" key={2}>
            <Section extraClasses="no-banner not-container" withoutContainer={true}>
            <div className="shadow-box margin-top margin-bottom">
                <h2 className="margin-bottom push-left">Search Centers and/or Doctors</h2>
                <form onSubmit={handleSubmit}>
                    <div className="push-left margin-bottom">
                        <label className="full-width">Type of Care</label>
                        <input type="checkbox" checked={typeAdult} onChange={() => setTypeAdult(!typeAdult)} /> Adult
                        <input type="checkbox" checked={typePediatrics} onChange={() => setTypePediatrics(!typePediatrics)} /> Pediatrics
                        {/* <input type="radio" value="adult" checked={type === 'adult'} onChange={typeClickHandle} /> Adult
                        <input type="radio" value="pediatrics" checked={type === 'pediatrics'}  onChange={typeClickHandle} /> Pediatrics */}
                    </div>
                    <div className="inputs-group full-width">
                        <div className="input-group">
                            <label>By Name</label>
                            <input type="text" ref={typeName} placeholder="Enter Center or Doctor" />
                        </div>
                        <div className="input-group">
                            <label>By Location</label>
                            <input type="text" ref={typeLocation} onChange={locationChangeHandle} placeholder="Enter Zip Code" className={ error.length > 0 ? "input-error" : ''} />
                        </div>
                        <div className="input-group">
                            <label>Radius</label>
                            <select defaultValue={20} ref={selectRadius}>
                                <option value={20}>20 miles</option>                                
                                <option value={10}>10 miles</option>
                                <option value={5}>5 miles</option>
                            </select>
                        </div>
                        <div className="input-group">
                            <Button clickHandle={() => {}}>Search</Button>
                        </div>
                    </div>
                </form>
                {error.length > 0 && <p className="push-left margin-top form-error">{error}</p>}
            </div>
        </Section>
    </div>
    ]
    );
}

export default Home;